<script>
    import {flow_steps} from '../stores.js';
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import CTA from './ctacomponent.svelte';
    import FooterComponent from './footercomponent.svelte';
    // export let step_info = "landing";
    import { onMount } from "svelte";

    export let progress_mobile_version = false;
    export let show_icon_card = true;

    let flow_choice = "purchase";

    let left_element;
    let right_element;

    onMount(async () => {
        setTimeout(() => {
            // console.log($flow_steps);
            if($flow_steps.current_flow.endsWith("p")){
                flow_choice = "purchase"
            }else{
                flow_choice = "refinance"
            }
        }, 100);
    });
</script>

<div class="maincontainer">
    <div bind:this={left_element} class="leftcontainer showdesktop">
        <div class="logocontainer">
            <a href="/"><img src="/img/HomeEasy_logo_dark_grey-01.png" alt="Semper Home Loans Logo"></a>
        </div>
        <!-- {#if show_icon_card}
        <div class="iconcard">
            <div class="iconcontainer"><img src="/img/icon_card_house.png" alt="Home"></div>
            <div class="iconlabelcontainer">New {flow_choice}</div>
        </div>            
        {/if} -->

    </div>

    <div bind:this={right_element} class="rightcontainer">
        <div class="navcontainer">
            <div class="dlogocontainer showdesktop">
                <a href="/"><img src="/img/HomeEasy_logo_dark_grey-01.png" alt="Semper Home Loans Logo"></a>
            </div>
            <div class="logocontainer showmobile">
                <a href="/"><img src="/img/HomeEasy_logo_dark_grey-01.png" alt="Semper Home Loans Logo"></a>
            </div>
    
            <div class="numbercontainer">
                <div class="phoneiconcontainer"><img src="/img/Phone_contact.svg" alt="Semper Home Loans Logo"></div>
                <div class="phonenumber"><a href="tel:866-528-3814">(866) 528-3814</a></div>
                <!-- <div class="signin">Sign In</div> -->
            </div>
    
        </div>

        <div class="stepcontainer">
            <slot></slot>
        </div>

        <div class="footercontainer">
            <FooterComponent 
            show_top_border={true}
            />
        </div>    

    </div>
</div>



<style>

.maincontainer {
    width: 100vw;
    height: 100% !important;
    /* height: 100vh; */
    display: flex;
    flex-direction: row;
    padding: 0px;
    background-color: white;
    box-sizing: border-box;
    /* overflow-y: scroll; */
}

.leftcontainer {
    background-color: var(--lightgray);
    width: 300px;
    max-width: 300px;
    min-width: 300px;
    /* width: 300px; */
    /* max-width: 300px; */
    /* min-width: 300px; */
    /* display: flex; */
    display: none;
    flex-direction: column;
    box-sizing: border-box;
    height: 100% !important;
}
.logocontainer {
    width: 100%;
    padding: 20px;
}
.logocontainer img {
    height: 36px;
}
.iconcard {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px;
}
.iconcontainer {
    height: 60px;
    width: 60px;
}
.iconcontainer img{
    height: 100%;
    width: 100%;
}
.iconlabelcontainer {
    margin-left: 16px;
}
.rightcontainer {
    width: 100vw;
    display: flex;
    flex-direction: column;
    background-color: white;
    height: 100% !important;
    overflow-y: scroll;
}
.dlogocontainer {
    height: 32px;
}
.dlogocontainer img {
    height: 100%;
}

.navcontainer {
    width: 80%;
    /* margin-left: auto; */
    /* margin-right: auto; */
    /* top: 0px; */
    left: 50%;
    transform: translateX(-50%);    
    display: flex;
    justify-content: space-between;
    padding: 20px 0px 20px 0px;
    align-items: center;
    box-sizing: border-box;
    position: fixed;
    z-index: 999;
    background-color: white;
}

.numbercontainer {
    display: flex;
    width: 150px;
    color: var(--placeholdergray);
    margin-right: 40px;
}
.phoneiconcontainer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.phoneiconcontainer img {
    width:  1em;
    height: 1em;
}
.phonenumber {
    font-size: 1em;
    margin-left: 10px;
}
.phonenumber a {
    text-decoration: none;
    color: var(--blueslate);
}
.stepcontainer {
    width: 50%;
    /* min-width: 800px; */
    /* height: 200px; */
    margin-left: auto;
    margin-right: auto;
    padding-top: 60px;
    /* padding-right: 300px; */
    /* margin-top: 80px; */
    /* background-color: white; */
}

.footercontainer {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 150px;
}
.showmobile {
    display: none;
}

@media (max-device-width: 1024px), (max-width: 1023px) {
    .showmobile {
        display: block;
    }
    .showdesktop {
        display: none;
    }
    .maincontainer {
        width: 100vw;
        left: 0px;
    }
    .rightcontainer {
        width: 100vw;
        box-sizing: border-box;
    }
    .navcontainer {
        border-bottom: 1px solid var(--darkgray);
        justify-content: space-between;
        box-sizing: border-box;
        position: relative;
        width: 100%;
        left: 0px;
        transform: none;

    }
    .logocontainer {
        width: auto;
        padding: 0px;
    }
    .logocontainer img {
        height: 32px;
    }
    
    .numbercontainer {
        width: auto;
        /* margin-right: 40px; */
    }
    .phonenumber {
        font-size: 0.75em;
        margin-left: 10px;
    }
    .stepcontainer {
        width: 100%;
        max-width: 350px;
        padding-right: 0px;

    }

}
</style>